import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../views/login'
// import Register from '@/views/register'
import Forgot from '@/views/forgot'
import store from '@/store'
const admin_id = store.state.admin_id

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => { })
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/first'),
    redirect: 'home', // 默认显示二级路由
    children: [
      {
        path: 'home',
        component: () => import('@/views/home')
      },
      {
        // 购物车成功下单
        path: 'success',
        name: 'success',
        // meta: { title: true },
        component: () => import('@/views/car/success')
      },
      {
        path: 'settle',
        name: 'settle',
        // meta: { title: true },
        component: () => import('@/views/car/settel/index.vue')
      },
      {
        path: 'settlle',
        name: 'settlle',
        component: () => import('@/views/settlle/settlle.vue')
      },
      {
        // 产品中心
        path: 'product',
        component: () => import('@/views/product')
      },
      {
        // 新产品
        path: 'newgoods',
        component: () => import('@/views/newGoods')
      },
      {
        // 降价产品
        path: 'reduction',
        component: () => import('@/views/reduction')
      },
      {
        // 手机端商品详情
        path: 'GoodsDetails',
        component: () => import('@/views/product/goodsDetails')
      },
      {
        // 购物车
        path: 'car',
        // meta: { title: true },
        component: () => import('@/views/car')
      },
      {
        // 搜索列表,
        path: 'serch',
        name: 'serch',
        component: () => import('@/views/serch')
      },
      {
        // 留言
        path: 'message',
        // meta: { title: true },
        component: () => import('@/views/message')
      },
      {
        path: 'personal',
        component: () => import('@/views/personal'),
        redirect: '/personal/my',
        children: [
          {
            path: 'my',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/my/my.vue'),

          },
          {
            // 我的留言
            path: 'leave',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/leave')
          },
          {
            // 留言详情
            path: 'leaveDetail',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/leave/leaveDetail')
          },
          {
            // 收藏夹
            path: 'collect',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/collect')
          },
          {
            path: 'order',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/order')
          },
          {
            // 订单详情
            path: 'details',
            name: 'details',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/order/details')
          },
          {
            // 个人信息
            path: 'myinfor',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/myinfor/myinfor.vue')
          },
          // 常购清单
          {
            path: 'detailed',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/detailed')
          },
          {
            // 申请开店
            path: 'openStore',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/openstore/openstore.vue')
          },
          {
            // 收货地址
            path: 'address',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/address'),
            children: [
              {
                // 修改地址+新增地址
                path: 'newAddress',
                component: () => import('@/views/personal/modifyaddress')
              }
            ]
          },
          {
            // 修改收货地址
            path: 'modify',
            name: 'modify',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/address/modify')
          },
          {
            // 新增收货地址
            path: 'addAddress',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/address/add')
          },
          {
            // 修改密码
            path: 'alterPassword',
            // meta: { title: true },
            meta: { requiresAuth: true },
            component: () => import('@/views/personal/alterPassword')
          },


        ]
      }
    ]
  },
  {
    path: '/login',
    // component: Login
    component: () => import('@/views/login')
  },
  {
    path: '/register',
    // component: Register
    component: () => import('@/views/register')
  },
  {
    // 找回密码
    path: '/forgot',
    component: Forgot
  },
  {
    // 找回密码第二部
    path: '/find',
    component: () => import('@/views/forgot/find/index.vue')
  },
  {
    // 完成找回密码
    path: '/over',
    component: () => import('@/views/forgot/over')
  }
]



const router = new VueRouter({
  // mode: 'history',
  linkActiveClass: "active",
  routes
})

// 定义需要登录才能访问的路由路径
// const requireAuthRoutes = ['/personal/my', '/personal/order', '/personal/detailed', '/personal/collect', '/personal/myinfor', '/personal/address', '/personal/alterPassword', '/personal'];
// function isLoggedIn() {
//   // 假设用户的登录状态信息存储在localStorage中的isLogged字段中
//   const vuexx = localStorage.getItem('vuex')

//   const isLogged = JSON.parse(vuexx).token;
//   console.log(vuexx, isLogged)
//   var flag = false
//   if (isLogged) {
//     flag = true
//   }
//   // flag = false
//   // 根据实际情况返回用户的登录状态
//   return flag;
// }
// // 导航守卫
// router.beforeEach((to, from, next) => {
//   // 判断当前路由是否需要登录
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // 判断用户是否已登录
//     if (!isLoggedIn()) {
//       // 未登录，跳转到登录页面
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath } // 将目标路由路径保存在查询参数中，以便登录后重定向
//       })
//     } else {
//       // 已登录，继续访问目标路由
//       next()
//     }
//   } else {
//     // 不需要登录，直接访问目标路由
//     next()
//   }
// })

export default router
